var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCloudNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icones"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.91536 12.25H18.082M8.16536 21.5017H12.832L18.0237 24.955C18.7937 25.4683 19.832 24.92 19.832 23.9867V21.5017C23.332 21.5017 25.6654 19.1683 25.6654 15.6683V8.66832C25.6654 5.16832 23.332 2.83499 19.832 2.83499H8.16536C4.66536 2.83499 2.33203 5.16832 2.33203 8.66832V15.6683C2.33203 19.1683 4.66536 21.5017 8.16536 21.5017Z",
    stroke: "#292B30",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCloudNormal);
export default __webpack_public_path__ + "static/media/chat-cloud-normal.899f9ec1b9493b9204edbd81e5c3cd61.svg";
export { ForwardRef as ReactComponent };